/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild, inject, DestroyRef, computed } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatMenuTrigger, MatMenuModule } from '@angular/material/menu';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { User } from '@src/app/model/user';
import { CurrentUserService } from '@src/app/modules/user/current-user.service';
import { NewButtonService } from '@src/app/shared/new-button/new-button.service';
import { AsyncPipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-new-button',
    templateUrl: './new-button.component.html',
    styleUrls: ['./new-button.component.scss'],
    imports: [MatButtonModule, RouterLink, MatIconModule, MatMenuModule, AsyncPipe]
})
export class NewButtonComponent implements OnInit {
  private breakpointObserver = inject(BreakpointObserver);
  private currentUserService = inject(CurrentUserService);
  private newButtonService = inject(NewButtonService);


  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  state = this.newButtonService.state;
  routerLink = computed(() => [this.state().link, this.state().actionParms]);

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(
    map(result => result.matches),
    shareReplay()
  );

  currentUser: User;

  private destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.currentUserService.getCurrentUser().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(user => { this.currentUser = user; });
  }

}
